export const getSolutionByName = (list, name) =>
  list.find((solution) => solution.name === name);

export const REAL_ESTATE_SOLUTIONS = [
  'bmsUpgrade',
  'commercialRepairs',
  'energyEfficiency',
  'led',
  'facadeRepairs',
  'fuelCell',
  'generators',
  'hvac',
  'lightningNonLed',
  'parkingRepairs',
  'publicInfrastructureIntervention',
  'photovoltaicPanels',
  'restrooms',
  'rhc',
  'roofRepairs',
  'structuralUpgradesAndRepairs',
  'equipmentReplacementOrUpgrade',
  'tradeDressReplacement',
  'wasteOther',
  'waterRelatedSystems',
  'ecopilot',
  'flooringRepairs',
  'safetyAndSecurity',
  'wasteWaterManagement',
  'evChargers',
  'legalOrContractual',
  'wasteBaler',
  'poweroptimiserEPower',
  'energyEnvelopeDoors',
  'energyEnvelopeRoof',
  'metering',
  'energyEnvelopeFacade',
  'adaptiveScheduling',
];
